import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BadgeCheckIcon, XIcon } from "lucide-react";
import { recentBuyers, MOCKUP_IMAGE } from "../data/offer";
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5000;
const GAP = 11000;
export function PurchasePopup() {
  const [index, setIndex] = useState(() => Math.floor(Math.random() * recentBuyers.length));
  const [minutesAgo, setMinutesAgo] = useState(2);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let showTimer = 0;
    let hideTimer = 0;
    const cycle = (delay: number) => {
      showTimer = window.setTimeout(() => {
        setIndex(i => (i + 1) % recentBuyers.length);
        setMinutesAgo(1 + Math.floor(Math.random() * 12));
        setVisible(true);
        hideTimer = window.setTimeout(() => {
          setVisible(false);
          cycle(GAP);
        }, VISIBLE_FOR);
      }, delay);
    };
    cycle(FIRST_DELAY);
    return () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(hideTimer);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <div className="pointer-events-none fixed inset-x-3 bottom-[96px] z-50 sm:inset-x-auto sm:left-5 sm:w-[360px]" aria-live="polite" data-id="element-44" data-mp="1fur121sjn9qe">
      <AnimatePresence data-id="element-45" data-mp="1axhcspgw5445">
        {visible && !dismissed && <motion.div key={`${buyer.name}-${minutesAgo}`} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex items-center gap-3 rounded-2xl border border-navy-900/10 bg-white p-3 pr-9 shadow-card" data-id="element-46" data-mp="n86bn6vmp7ph">
            <div className="flex h-14 w-14 shrink-0 items-center justify-center overflow-hidden rounded-xl bg-surface" data-id="element-47" data-mp="23ld8prymyrzv">
              <img src={MOCKUP_IMAGE} alt="" className="h-full w-full object-contain" data-id="element-48" data-mp="2ap30h91dqoan" />
            </div>
            <div className="min-w-0" data-id="element-49" data-mp="2fmv3oz7h5wu5">
              <p className="truncate text-sm font-extrabold text-ink" data-id="element-50" data-mp="2fltfdt1g7duh">
                {buyer.name} <span className="font-semibold text-ink-muted" data-id="element-51" data-mp="2ko276m2l49v0">from {buyer.country}</span>
              </p>
              <p className="text-[13px] leading-snug text-ink" data-id="element-52" data-mp="2plby665mgtky">just purchased the Self-Ligating Blueprint™</p>
              <p className="mt-0.5 flex items-center gap-1 text-[11px] font-semibold text-success" data-id="element-53" data-mp="1rzwm1y7mciun">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-54" data-mp="1wv2950crc3kb" />
                Verified purchase · {minutesAgo} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-md p-1 text-ink-muted transition-colors duration-150 hover:bg-surface hover:text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-brand" aria-label="Dismiss notification" data-id="element-55" data-mp="26o16p7q8f4g2">
              <XIcon className="h-4 w-4" data-id="element-56" data-mp="3nfmojafy7n5u" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}